import { useState } from "react";
import { deleteData } from "../../services/api";

const useDelete = (endpoint) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const deleteDataById = async (id) => {
    setLoading(true);
    try {
      const response = await deleteData(`${endpoint}/${id}`);
      setData(response.data);
      setError(null)
    } catch (err) {
      setError(err);
      throw err
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, deleteData: deleteDataById, setError };
};

export default useDelete;